import { useMemo } from 'react'

let CHARGE_TYPES = /** @type {const} */ ([
  'LateFeeCharge',
  'MiscFeeCharge',
  'RetailFeeCharge',
  'TxFeeCharge',
])
let ADJUSTMENT_TYPES = /** @type {const} */ (['DiscountAdjustment', 'WriteOff'])
let CORRECTION_TYPES = /** @type {const} */ ([
  'FixAdjustment',
  'MigrationFixAdjustment',
])

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let result = []
    for (let transaction of data) {
      if (CHARGE_TYPES.includes(transaction.dtype)) {
        if (
          result.length > 0 &&
          result[result.length - 1].dtype === 'Charge' &&
          result[result.length - 1].sys_created_by ===
            transaction.sys_created_by
        ) {
          // an aggregation of charges it's already started, appending to it
          result[result.length - 1].entries.push(transaction)
        } else {
          // start a new aggregation entry for the charges
          result.push({
            dtype: 'Charge',
            id: transaction.id,
            sys_created: transaction.sys_created,
            sys_created_by: transaction.sys_created_by,
            created_by_user: transaction.created_by_user,
            entries: [transaction],
          })
        }
      } else if (ADJUSTMENT_TYPES.includes(transaction.dtype)) {
        if (
          result.length > 0 &&
          result[result.length - 1].dtype === 'Adjustment' &&
          result[result.length - 1].sys_created_by ===
            transaction.sys_created_by
        ) {
          // an aggregation of Adjustments it's already started, appending to it
          result[result.length - 1].entries.push(transaction)
        } else {
          // start a new aggregation entry for the Adjustments
          result.push({
            dtype: 'Adjustment',
            id: transaction.id,
            sys_created: transaction.sys_created,
            sys_created_by: transaction.sys_created_by,
            created_by_user: transaction.created_by_user,
            entries: [transaction],
          })
        }
      } else if (CORRECTION_TYPES.includes(transaction.dtype)) {
        if (
          result.length > 0 &&
          result[result.length - 1].dtype === 'Correction' &&
          result[result.length - 1].sys_created_by ===
            transaction.sys_created_by
        ) {
          // an aggregation of Corrections it's already started, appending to it
          result[result.length - 1].entries.push(transaction)
        } else {
          // start a new aggregation entry for the Corrections
          result.push({
            dtype: 'Correction',
            id: transaction.id,
            sys_created: transaction.sys_created,
            sys_created_by: transaction.sys_created_by,
            created_by_user: transaction.created_by_user,
            entries: [transaction],
          })
        }
      } else {
        // no need to aggregate multiple transactions, will remain unchanged
        result.push(transaction)
      }
    }

    return result
  }, [data])
}
